import axios from 'axios';

import { API_BASE_URL, API_BASE_URL_API } from '../config/api';

function getToken(): string | null {
  try {
    // Support a few historical/local keys to reduce login surprises.
    // Primary key is `auth_token`.
    const keys = ['auth_token', 'token', 'jwt_token', 'admin_jwt_token'];
    for (const key of keys) {
      const raw = localStorage.getItem(key);
      if (raw) return raw;
    }
    return null;
  } catch {
    return null;
  }
}

export const http = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    (config.headers as any)['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const httpApi = axios.create({
  baseURL: API_BASE_URL_API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

httpApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    (config.headers as any)['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export function setToken(token: string | null) {
  try {
    if (token) {
      localStorage.setItem('auth_token', token);
      // Compatibility: some tooling/docs refer to `token`.
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('token');
    }
  } catch {
    // ignore
  }
}


